import React, { useState, useEffect } from "react";
import { string, node, func, number } from "prop-types";
import { SectionHeading } from "../../atoms/SectionHeading";
import { PARTICIPANTS_SECTION_CONSTANTS } from "../../../constants";
import { ArrowIcon } from "../../../../assets/icons/ArrowIcon";
import { RightArrowIcon } from "../../../../assets/icons/RightArrowIcon";
import "./participants-section.m.css";

export const ParticipantsSection = ({
  title = "Participants",
  description = "",
  linkText = "View all participants",
  ctaHeading,
  backgroundImage,
  imageCaption,
  onViewAllClick,
  participantsCount = 0,
  onBookSeatClick,
  hasUserPurchasedStory,
}) => {
  const handleViewAllClick = (e) => {
    e.preventDefault();
    if (onViewAllClick) {
      onViewAllClick();
    }
  };

  return (
    <div styleName="participants-section" data-section="participants">
      <div styleName="cta-section">
        <div styleName="cta-content">
          <div styleName="cta-heading">
            <div styleName="cta-heading-text">
              <div styleName="cta-heading-wrapper">
                <SectionHeading>
                  {ctaHeading ? (
                    <span dangerouslySetInnerHTML={{ __html: ctaHeading }} />
                  ) : (
                    PARTICIPANTS_SECTION_CONSTANTS.DEFAULT_CTA_HEADING
                  )}
                </SectionHeading>
              </div>
            </div>
          </div>
          <div styleName="cta-button-text">
            <button onClick={onBookSeatClick} styleName="cta-button" disabled={hasUserPurchasedStory}>
              Book your seat now
            </button>
            <div styleName="cta-hint">
              Filling up fast
            </div>
          </div>
        </div>
      </div>
      <div styleName="image-container">
        <div styleName="background-image">
          {backgroundImage}
        </div>
        <div styleName="content-caption">
          <div styleName="participants-content">
            <SectionHeading>{title}</SectionHeading>
            <div styleName="section-paragraph" dangerouslySetInnerHTML={{ __html: description }} />
            {Boolean(onViewAllClick) && (
              <div styleName="section-link">
                <button
                  type="button"
                  styleName="link-content"
                  onClick={handleViewAllClick}
                >
                  <div styleName="link-text">
                    {linkText}
                  </div>
                  <div styleName="link-icon">
                    <RightArrowIcon />
                  </div>
                </button>
              </div>
            )}
          </div>
          <div styleName="caption" dangerouslySetInnerHTML={{ __html: imageCaption || PARTICIPANTS_SECTION_CONSTANTS.DEFAULT_CAPTION }} />
        </div>
      </div>
    </div>
  );
};

ParticipantsSection.propTypes = {
  title: string,
  description: string,
  linkText: string,
  ctaHeading: string,
  backgroundImage: node,
  imageCaption: string,
  onViewAllClick: func,
  participantsCount: number,
};